import { FC } from "react";
import type { BookingDetailResult } from "src/store/slices/hotels/Hotels";
import BookingHero from "../newComponents/BookingHero";
import BookingSummary from "../newComponents/BookingSummary";
import StayChips from "../newComponents/StayChips/StayChips";
import RoomSelection from "../newComponents/RoomSelection";
import GuestDetails from "../newComponents/GuestDetails";

const HotelBookingResultNewWeb: FC<{ bookingDetail: BookingDetailResult }> = ({ bookingDetail }) => {
  const status = bookingDetail.orderStatus;
  // failed bookings come back without hotel / room data, so only the hero is shown
  const hasBookingDetails = !!bookingDetail.hotelDetails;

  return (
    <div className="w-full flex justify-center items-center flex-col gap-4">
      <BookingHero status={status} referenceNumber={bookingDetail.referenceNumber} />
      {hasBookingDetails && (
        <div className="w-[70%] flex flex-col gap-4 items-center justify-center">
          <StayChips bookingDetail={bookingDetail} />
          <BookingSummary bookingDetail={bookingDetail} />
          <GuestDetails bookingDetail={bookingDetail} />
          <RoomSelection bookingDetail={bookingDetail} />
        </div>
      )}
    </div>
  );
};

export default HotelBookingResultNewWeb;
